import React from "react";
import ReactSelectInput from "../../../Components/Inputs/ReactSelectInput";
import OrderProducts from "./OrderProducts";
import TextareaInput from "../../../Components/Inputs/TextareaInput";
import {PAYMENT_METHODS} from "../../../Constants/Constants";
import SelectPicker from "../../../Components/Inputs/rsuite/SelectPicker";

export default function ({register, errors, control, data, setData, watch}) {

  return (
    <>
      <SelectPicker
        label="Customer"
        name="user_id"
        className="col-md-12 col-sm-12 pt-3"
        options={data?.customers}
        control={control}
        errorMessage={errors?.user_id}
        required={true}
        size='lg'
      />

      {
        watch('user_id') && (
          <ReactSelectInput
            label="Address"
            name="customer_address_id"
            className="col-md-12 col-sm-12 pt-3"
            options={data?.addresses}
            control={control}
            errorMessage={errors?.customer_address_id}
            required={true}
          />
        )
      }

      <div className="col-12 mt-5 mb-5">
        <OrderProducts data={data} setData={setData} watch={watch} errors={errors} control={control}
                       register={register}/>
      </div>

      <ReactSelectInput
        label="Payment Method"
        name="payment_method"
        className="col-md-12 col-sm-12 pt-3"
        options={data?.payment_methods}
        control={control}
        errorMessage={errors?.payment_method}
        required={true}
      />

      {
        watch('payment_method') && watch('payment_method') === PAYMENT_METHODS.CARD && (
          <ReactSelectInput
            label="Payment Provider"
            name="payment_provider"
            className="col-md-12 col-sm-12 pt-3"
            options={data?.payment_providers}
            control={control}
            errorMessage={errors?.payment_provider}
            required={true}
          />
        )
      }

      <TextareaInput
        label="Comment"
        name="comment"
        register={register}
        rows={3}
        watch={watch}
        errorMessage={errors?.comment}
      />
    </>
  );
}